// Copyright (c) 2016 Deere & Company

import Tab from '../../../../src/shared/state/tab';

export const getNavigationTabs = (countObject, hasSearchResults, showLaborAdditive) => {

    const navigationTabs = [
        new Tab({
            count: countObject.openPips,
            label: 'OPEN_PIPS_TAB',
            route: '/pips/open-pips'
        })
    ];

    if (showLaborAdditive) {

        navigationTabs.push(new Tab({
            count: countObject.laborAdditive,
            label: 'LABOR_ADDITIVE_TAB',
            route: '/pips/labor-additive'
        }));

    }

    if (hasSearchResults) {

        navigationTabs.push(new Tab({
            count: countObject.pipSearch,
            label: 'SEARCH_RESULTS_TAB',
            route: '/pips/search'
        }));

    }

    return navigationTabs;

};



// WEBPACK FOOTER //
// ./src/pip/shared/services/pip-navigation-helper.js